var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotify4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39648 8.01617L4.16323 10.1278L8.6059 5.0505L7.7274 4.28284L4.0034 8.53884L2.10348 7.08867L1.39648 8.01617ZM12.6892 5.0505L11.8107 4.28284L8.09548 8.52892L7.65623 8.17775L6.92707 9.08892L8.23782 10.1378L12.6892 5.0505Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotify4);
export default __webpack_public_path__ + "static/media/icNotify4.297ecab3b4f66280f7194b55e3644898.svg";
export { ForwardRef as ReactComponent };